






































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { DataOptions } from 'vuetify'
import axios, { CancelTokenSource } from 'axios'
import RangeDatePicker from '@/components/ui/RangeDatePicker.vue'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { listarEnviosDeEmail } from '@/api/integracaoDeEmail'
import {
	EnvioDeEmail,
	StatusDeEnvioDeEmail,
	TipoDeEnvioDeEmail,
	statusDeEnvioDeEmail,
	tiposDeEnvioDeEmail,
} from '@/models/email/EnvioDeEmail'
import { sortConverter } from '@/shareds/paginacao'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'

@Component({
	components: {
		RangeDatePicker,
		SeletorDeLojasDoUsuario,
	},
})
export default class TelaDeRegistroDeEnviosDeEmail extends Vue {
	itens: EnvioDeEmail[] = []
	totalDeRegistros = 0
	buscando = false
	mostrarFiltros = false
	cancelToken: CancelTokenSource | null = null

	statusDeEnvio = statusDeEnvioDeEmail
	tiposDeEnvio = tiposDeEnvioDeEmail

	filtro = {
		lojaId: null as string | null,
		status: null as StatusDeEnvioDeEmail | null,
		tipo: null as TipoDeEnvioDeEmail | null,
		datas: [] as string[],
		busca: '',
	}

	headers = [
		{ text: 'Data e hora', value: 'dataHora' },
		{ text: 'Venda', value: 'identificadorDaVenda', sortable: false },
		{ text: 'Tipo', value: 'tipoDescricao', sortable: false },
		{ text: 'Destinatário', value: 'destinatario', sortable: false },
		{ text: 'Status', value: 'status', sortable: false },
		{ text: 'Motivo da falha', value: 'motivoDaFalha', sortable: false },
		{ text: 'Código do envio', value: 'codigoDoEnvio', sortable: false },
	]

	paginacao: DataOptions = {
		page: 1,
		itemsPerPage: 10,
		sortBy: ['dataHora'],
		sortDesc: [true],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	get itensFormatados() {
		return this.itens.map(item => ({
			...item,
			dataHora: item.dataHora ? dateTimeToPtBrFormat(item.dataHora) : '',
			identificadorDaVenda: item.identificadorDaVenda || '—',
		}))
	}

	get periodoDaBusca() {
		const [dataInicial, dataFinal] = [...this.filtro.datas].sort()
		return { dataInicial, dataFinal }
	}

	pesquisar() {
		if (this.paginacao.page !== 1) {
			this.paginacao = { ...this.paginacao, page: 1 }
			return
		}
		this.buscar()
	}

	async buscar() {
		if (this.cancelToken) this.cancelToken.cancel()
		const cancelToken = axios.CancelToken.source()
		this.cancelToken = cancelToken
		this.buscando = true
		try {
			const sort = sortConverter(this.paginacao)
			const pagina = await listarEnviosDeEmail({
				lojasIds: this.filtro.lojaId ? [this.filtro.lojaId] : undefined,
				status: this.filtro.status || undefined,
				tipo: this.filtro.tipo || undefined,
				dataInicial: this.periodoDaBusca.dataInicial || undefined,
				dataFinal: this.periodoDaBusca.dataFinal || undefined,
				busca: this.filtro.busca?.trim() || undefined,
				page: this.paginacao.page - 1,
				size: this.paginacao.itemsPerPage,
				sort: sort.length ? sort : ['dataHora,DESC'],
			}, { cancelToken: cancelToken.token })
			this.itens = pagina.content
			this.totalDeRegistros = pagina.totalElements
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
		} finally {
			if (this.cancelToken === cancelToken) this.buscando = false
		}
	}

	async copiar(codigo: string) {
		try {
			await navigator.clipboard.writeText(codigo)
			AlertModule.setInfo('Código do envio copiado.')
		} catch {
			AlertModule.setInfo(`Código do envio: ${codigo}`)
		}
	}

	@Watch('paginacao', { deep: true })
	onChangePaginacao() {
		this.buscar()
	}
}
